/**
 * ClinicsSegmentTabs — flat full-width tab strip (design §3).
 */

import { Buildings, HandCoins, Hourglass, Prohibit, SignOut, Sparkle, WarningCircle } from "@phosphor-icons/react";
import { SEGMENTS } from "../shared/nivDerived";

const ICONS = {
  all: Buildings,
  new: Sparkle,
  trial: Hourglass,
  paying: HandCoins,
  risk: WarningCircle,
  left: SignOut,
  inactive: Prohibit,
};

function ClinicsSegmentTabs({ active, counts, onChange }) {
  return (
    <div className="nivck2-tabs" role="tablist">
      {SEGMENTS.map((seg) => {
        const Icon = ICONS[seg.id];
        const isActive = active === seg.id;
        const count = counts[seg.id] || 0;
        if ((seg.id === "inactive" || seg.id === "left") && count === 0 && !isActive) return null;
        return (
          <button
            key={seg.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`nivck2-tab nivck2-tab-${seg.id}${isActive ? " active" : ""}`}
            onClick={() => onChange(seg.id)}
          >
            <Icon size={15} weight={isActive ? "fill" : "regular"} />
            <span className="nivck2-tab-label">{seg.label}</span>
            <span className="nivck2-tab-count">{count}</span>
          </button>
        );
      })}
    </div>
  );
}

export default ClinicsSegmentTabs;
